import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shared/ui';
import { COUNTRIES } from '@shared/lib/countries';

interface CountrySelectProps {
  value: string | null | undefined;
  onChange: (code: string | null) => void;
  id?: string;
  invalid?: boolean;
  'aria-describedby'?: string;
}

export function CountrySelect({ value, onChange, id, invalid, ...aria }: CountrySelectProps) {
  return (
    <Select
      value={value ?? undefined}
      onValueChange={(v) => onChange(v || null)}
    >
      <SelectTrigger id={id} invalid={invalid} aria-describedby={aria['aria-describedby']}>
        <SelectValue placeholder="Select country" />
      </SelectTrigger>
      <SelectContent>
        {COUNTRIES.map((c) => (
          <SelectItem key={c.code} value={c.code}>
            {c.nameEn} ({c.code})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
